import AdvancedFiltersView from './advanced_filters_view';

export default AdvancedFiltersView.extend({
  events: {
    'click .js-cancel-button': 'onCancel',
    'click .js-search-button': 'onSubmit',
    'click .js-reset-filters': 'resetFilters',
  },

  initialize(options) {
    AdvancedFiltersView.prototype.initialize.call(this, options);
    this.title = options.title;

    this.$el.on('shown.bs.modal', _.bind(this.recordEvent, this));
  },

  recordEvent() {
    const eventName = `${this.title} Modal Shown`;
    dataLayer.push({
      event: 'record-event',
      event_name: eventName,
    });
  },

  onCancel() {
    this.model.reset();
  },

  onSubmit() {
    this.model.send();
  },

  resetFilters() {
    _.each(this.$('.js-search-advanced-filter-checkbox input'), checkbox => {
      $(checkbox)
        .prop('checked', false)
        .trigger('change');
    });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/advanced_filters_modal_view.js